module.exports = __webpack_public_path__ + "img/mn_get.73d040b.png";